<!-- MAIN SECTION  -->
<div class="lg:flex gap-3">
	<main class="rounded-12px bg-off-white p-24px basis-3/4 md:basis-4/4">
		<!-- COUNTRIES SECTION  -->

		<div
			class="max-w-[406px] flex justify-evenly items-center py-[8px] max-mobile:p-0 px-[10px] bg-off-white rounded-[50px] text-dark-grey mt-[18px] text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
		>
			<a
				routerLink="/layout/wallet/financial-list"
				[queryParams]="{ country: country.id }"
				*ngFor="let country of activeCountries"
				class="text-center w-[55%] max-mobile:m-[3px]"
				[ngClass]="{ activeClass: financialFilter.countryId == country.id }"
			>
				<!-- prettier-ignore -->
				<img class="inline-block w-[24px] max-mobile:hidden max-mobile:w-full max-mobile:text-font-mobile-small" [src]="attachmentUrl + country.flagUrl" alt="" />
				{{
					this.translate.currentLang === 'ar'
						? country?.name?.ar
						: country?.name?.en
				}}
			</a>
		</div>
		<!-- COUNTRIES SECTION  -->
		<!-- FILTER SECTION  -->
		<div class="mb-[18px]">
			<app-search-filter
				searchKey="ORGANIZATION.ORGANIZATION_LIST.SEARCH"
				(keyWord)="financialFilter.searchText = $event; getListData(true)"
				[filterCount]="filterCount"
				(toggleFilter)="sidenav.toggle()"
				(resetFilter)="filter.resetFilter()"
			></app-search-filter>
		</div>
		<!-- FILTER SECTION  -->
		<app-finance-payment-method-filter
			[totals]="totals"
			(emitActiveStatus)="
				financialFilter.activeTab = $event;
				financialFilter.paging.pageNumber = 1;
				getListData()
			"
			[activeStatus]="financialFilter.activeTab"
		></app-finance-payment-method-filter>
		<div class="mt-[18px]">
			<app-financial-table
				[listData]="listData"
				[activeStatus]="financialFilter.activeTab"
				[financialFilter]="financialFilter"
				[totalCount]="totalCount"
			></app-financial-table>
		</div>
		<app-no-data-found *ngIf="!totalCount"></app-no-data-found>
		<!-- pagination -->
		<div class="pt-[24px] max-mobile:overflow-auto">
			<app-pagination
				[totalCount]="totalCount"
				[pageNumber]="financialFilter.paging.pageNumber"
				[pageCount]="financialFilter.paging.pageSize"
				(currentPage)="pageChanged($event, financialFilter.paging.pageSize)"
				(itemsCountPerPage)="pageChanged(1, $event)"
			></app-pagination>
		</div>
	</main>

	<div
		class="basis-1/4 rounded-12px bg-off-white max-w-full max-h-[365px] md:basis-4/4"
	>
		<div>
			<mat-card
				appearance="outlined"
				[class.mat-mdc-elevation-z2]="false"
				class="calendar-card bg-off-white relative"
				[ngClass]="
					selectedDateRange != undefined || !dateChange
						? 'calendar'
						: 'custom-bg'
				"
			>
				<a
					*ngIf="selectedDateRange != undefined"
					class="cursor-pointer absolute right-1"
					(click)="reset()"
				>
					<button class="flex text-link">
						{{ 'ACTIONS.RESET' | translate }}
						<img
							class="align-middle mx-2"
							src="assets/images/icon-reset.svg"
							alt="icon"
						/>
					</button>
				</a>
				<mat-calendar
					#calendar
					[ngClass]="selectedDateRange != undefined ? 'custom-bg' : 'calendar'"
					[(selected)]="selectedDateRange"
					(selectedChange)="rangeChanged($event)"
				></mat-calendar>
			</mat-card>
		</div>
	</div>
</div>

<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-financial-filter
				#filter
				[filterData]="financialFilter"
				(emitFilter)="getListData(true, $event); sidenav.toggle()"
				(emitfilterCount)="filterCount = $event"
			></app-financial-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>
<!-- MAIN SECTION  -->
